import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Quiz, QuizzesResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class QuizzesDataService {

  private uri: string = `${environment.apiUrl}quiz`;
  private cacheKey: string = 'quizzes.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getQuiz(id: number): Observable<Quiz|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getQuizzes(parameters: {[param: string]: string | string[]}): Observable<QuizzesResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addQuiz(data: Quiz): Observable<Quiz|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addQuizzes(data: Quiz[]): Observable<Quiz[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateQuiz(data: Quiz): Observable<Quiz|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateQuizzes(data: Quiz[]): Observable<Quiz[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchQuiz(data: Quiz): Observable<Quiz|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchQuizzes(data: Quiz[]): Observable<Quiz[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteQuiz(data: Quiz): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteQuizzes(data: Quiz[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((quiz) => {
      ids.push(quiz.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
